import { Link } from 'react-router-dom';
import { useEffect } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import CategorySection from './components/CategorySection';
import ContentSections from './components/ContentSections';
import Footer from './components/Footer';

export default function Home() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, []);

  return (
    <>
      <title>Sugargoo Spreadsheet 2026 | Best Finds, Reviews, Shipping Guide & Coupons</title>
      <meta name="description" content="Discover the ultimate Sugargoo Spreadsheet 2026 hub. Find updated product spreadsheets, Sugargoo reviews, shipping costs, coupons, warehouse guides and expert shopping tips." />
      <link rel="canonical" href="https://sugargoospread.top/" />
      <script type="application/ld+json">
        {JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'WebSite',
          name: 'Sugargoo Spreadsheet Hub',
          url: 'https://sugargoospread.top',
          description: 'The most complete Sugargoo Spreadsheet resource hub helping users discover products, compare information, and shop smarter.',
          image: 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/1fc56da0b352904925ac780066826afe.jpeg',
          potentialAction: {
            '@type': 'SearchAction',
            target: {
              '@type': 'EntryPoint',
              urlTemplate: 'https://sugargoospread.top/search?q={search_term_string}'
            },
            'query-input': 'required name=search_term_string'
          }
        })}
      </script>

      <div className="min-h-screen flex flex-col">
        <Navbar />
        <main>
          <Hero />
          <CategorySection />
          <ContentSections />
        </main>
        <Footer />
      </div>
    </>
  );
}